import React, { useEffect, useState, useRef } from 'react';
import useReduxState from 'src/hooks/useReduxState';
import { isObject, isString } from "underscore";
import $ from "jquery";
import { useAxiosIndicatorCheck } from "../../store/hook/useAxiosIndicatorCheck";
import ShowMoreLess from 'src/component/custom/ShowMoreLess';
import { __remove, __set } from 'src/store/axios_indicator';
import addpartarrow from "src/assets/images/addpart-arrow.svg";
import getSymbolFromCurrency from 'currency-symbol-map';
import { useProductStore } from 'src/hooks/product';
import { useBOMStore } from 'src/hooks/bom';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
const AddPartAutoComplete = (props) => {
  const wrapperRef = useRef(null);
  const [__check] = useAxiosIndicatorCheck();
  const [{ }, { }, { set_bom_multi_match_trigger }] = useBOMStore();
  const [searchTerm, setSearchTerm] = useReduxState('', 'setAutoCompleteSearchTerm')
  const [keyPress, setKeyPress] = useState(false)
  const clsClose = "dropdown search-part w280 "
  const clsOpen = clsClose + "open";
  const [classToToggle, setClassToToggle] = useState(clsClose);
  const [productListGroup, setProductListGroup] = useState({});
  const [searchProductList, setSearchProductList] = useState({});
  const [backButtonClick, setBackButtonClick] = useState(false)
  const [productSelected, setProductSelected] = useReduxState({}, 'setAutoCompleteProductSelected')
  const [{ }, { get_pricing_by_id }, { }] = useProductInventoryPriceStore();
  const [{ }, { get_product_pricing_inventory, fetch_GroupedProducts_ObjectBy_SearchParam, check_CPN_AvailableIn_List }, { }] = useProductStore();
  const [selectedTab, setSelectedTab] = useReduxState("BomExactMatchTable", "searchParams");
  const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
  useEffect(() => {
    async function fetchHere() {
      $(document).on('click', '.dropdown-menu', function (e) {
        e.stopPropagation();
      });

      document.addEventListener("click", handleClickOutside, false);
      return () => {
          document.removeEventListener("click", handleClickOutside, false);
      };
    }

    fetchHere()
  }, []);

  useEffect(() => {

    if (searchTerm.trim().length === 0) {
      setClassToToggle(clsClose)
    }

    const delayDebounceFn = setTimeout(async () => {
      // after product selection it'll not going to trigger API
      if (searchTerm && searchTerm.length > 2 && keyPress) {
        await typingCompleted(searchTerm)
        setKeyPress(false)
      }
    }, 1000);

    return () => clearTimeout(delayDebounceFn)

  }, [searchTerm, keyPress]);

  const handleClickOutside = event => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
          setClassToToggle(clsClose)
      }
  };

  const typingCompleted = async (searchTerm) => {
    let res = await fetchFromServer(searchTerm);
    setProductListGroup(res);
    setSearchProductList({});
    if (searchTerm.length < 1) {
      setClassToToggle(clsClose)
      await setProductListGroup({})
    }
  };

  useEffect(() => {
    if (backButtonClick) {
      let manualPartElem = document.getElementById('manual-add-part-box');
      if (manualPartElem) {
        if (manualPartElem.classList && !manualPartElem.classList.contains('open')) {
          setClassToToggle(clsOpen)
        }
        setBackButtonClick(false);
      }
    }
  }, [backButtonClick])

  const selectProduct = async (productHere) => {
    __set('MANUAL_SEARCH_API_CALL')
    if (productHere.Count && productHere.Count > 1) {
      setTimeout(() => {
        let manualPartElem = document.getElementById('manual-add-part-box');
        if (manualPartElem) {
          manualPartElem.removeAttribute('class');
          manualPartElem.setAttribute('class', clsOpen);
        }
      }, 1200);
      let res = await fetch_GroupedProducts_ObjectBy_SearchParam(productHere.ERPMFRPartNumber, productHere.ManufacturerName, false, true);

      setSearchProductList(res);

    } else if (productHere.ItemNumber) {
      const selectedProductList = await get_product_pricing_inventory([{ ItemNumber: productHere.ItemNumber }])

      if (selectedProductList[productHere.ItemNumber]) {
        const currentItem = selectedProductList[productHere.ItemNumber];
        let selectedSearchCPN = ''
        if (currentItem.CustomerPartNumbers && currentItem.CustomerPartNumbers?.length > 0) {
          selectedSearchCPN = await check_CPN_AvailableIn_List(currentItem.CustomerPartNumbers, searchTerm);
        }
        setProductSelected({ ...currentItem, "selectedSearchCPN": selectedSearchCPN });
        setClassToToggle(clsClose);
        //added by Ramya
        if(props.fromComponent === "bomTabs"){
          addPartEvent(currentItem);
        }
        if (currentItem.ERPMFRPartNumber) {
          setSearchTerm(currentItem.ERPMFRPartNumber); //After Product Set That Part number in search
        }
      } else {
        setProductSelected({});
        system_alert_indicator({
          name: 'notGivingProduct',
          message: 'Main API is not giving Product Detailed data. on:' + productHere.ItemNumber,
          type: "danger"
        })
        setClassToToggle(clsOpen)
      }
      if (selectedTab !== 'BomExactMatchTable') {
        set_bom_multi_match_trigger({
          BOMTriggerVal: 'BOM_EXACT_TRIGGER'
        })
      }
    }
    __remove('MANUAL_SEARCH_API_CALL')
  };

   //By Ramya Kannan [Quickly add a part - Adobe script ]
   function addPartEvent(prodData){
    if(Object.keys(prodData).length){
        localStorage.setItem("prodPayload",JSON.stringify(prodData));
        localStorage.setItem("adobeEventType","bomQuicklyAddPart");
    }
   
}

  const fetchFromServer = async (searchTermHere) => {
    if (isString(searchTermHere)) {
      searchTermHere = searchTermHere.trim()
    }
    let res = await fetch_GroupedProducts_ObjectBy_SearchParam(searchTermHere);
    setClassToToggle(clsOpen)
    return res;
  };

  const getSearchStringBold = (string) => {
    return (
      <>
        {isString(string) &&
          <div
            dangerouslySetInnerHTML={{ __html: string.toUpperCase().replaceAll(searchTerm.toUpperCase(), "<span className='text-blue2'>" + searchTerm.toUpperCase() + "</span>") }} />
        }
      </>
    )
  };

  const getProductGroupItem = (productListHere) => {
    return (
      <>
        {productListHere && Object.keys(productListHere).map((p) => (
          <li key={p} onClick={async () => {
            await selectProduct(productListHere[p])
          }}>
            {!__check(['PRODUCT_MANUAL_SEARCH_LISTING_API_CALL', 'PRODUCT_INVENTORY_API_CALL', 'MANUAL_SEARCH_API_CALL']).status &&
              <>
                <div className="product-part-name">
                  <span>
                    {getSearchStringBold(productListHere[p].ERPMFRPartNumber)}
                  </span>
                </div>
                <div className="product-part-detail">
                  <div className="text-black">
                    <span className="text-black">
                      {productListHere[p].Count > 1 ? "" : productListHere[p].ManufacturerName ? productListHere[p].ManufacturerName : ''}
                    </span>
                  </div>
                  {productListHere[p].Count > 1 &&
                    <div className="text-black">
                      <div>
                        {productListHere[p].Count} products found
                        in {productListHere[p].ManufacturerName}
                      </div>
                    </div>
                  }

                  {productListHere[p].Count <= 1 &&
                    <div>
                      {productListHere[p].ShortDescription ?
                        <ShowMoreLess single_product={productListHere[p]} /> : ''
                      }
                    </div>
                  }
                </div>
              </>
            }

          </li>
        ))
        }
        {!(productListHere && Object.entries(productListHere).length > 0) &&
          !__check(['PRODUCT_MANUAL_SEARCH_LISTING_API_CALL', 'PRODUCT_INVENTORY_API_CALL', 'MANUAL_SEARCH_API_CALL']).status &&
          <li>
            <div className="no-part-data">
              {!__check(['PRODUCT_MANUAL_SEARCH_LISTING_API_CALL', 'PRODUCT_INVENTORY_API_CALL', 'MANUAL_SEARCH_API_CALL']).status &&
                <>(0) Results Found</>
              }
            </div>
          </li>
        }
      </>
    )
  };

  const template_for_add_part_pricing = (single_product_pricing_list) => {
    return (
      <>
        {single_product_pricing_list && isObject(single_product_pricing_list) &&
          <div className={`price-table-list w130 ${(single_product_pricing_list[0]?.quantity > 0 || single_product_pricing_list[0]?.marketPrice) && "price-table-list-with-border"}`}>
            <div className='bs5 row mx-0'>
              <div className="ps-0 col-6 font-12"><span>{single_product_pricing_list[0]?.quantity > 0 && single_product_pricing_list[0]?.quantity + "+"}</span></div>
              <div className="pe-0 col-6 text-end font-12">
                <span>{getSymbolFromCurrency(single_product_pricing_list[0]?.currency)}{single_product_pricing_list[0]?.marketPrice}</span></div>
            </div>
          </div>
        }
      </>
    )
  };

  const getProductItem = (productListHere) => {
    return (
      <>
        {productListHere && Object.keys(productListHere).map((p) => (
          <li key={p} onClick={async () => {
            await selectProduct(productListHere[p])
          }}>
            <>
              <div className="product-part-name">
                <span>
                  {getSearchStringBold(productListHere[p].ERPMFRPartNumber ? productListHere[p].ERPMFRPartNumber : '')}
                </span>
              </div>
              <div className="product-part-detail">
                <div className="text-black">
                  {template_for_add_part_pricing(get_pricing_by_id({
                    ItemNumber: productListHere[p].ItemNumber
                  }))}
                </div>
                <div className='mt-2'>
                  {productListHere[p].ShortDescription && productListHere[p].ShortDescription.trim() != '' ?
                    <ShowMoreLess single_product={productListHere[p]} /> : ''
                  }
                </div>

                <div className='mt-4'>
                  {productListHere[p].PackagingTypeCode ?
                    productListHere[p].PackagingTypeCode : ''
                  }
                </div>
              </div>
            </>
          </li>
        ))
        }
        {!(productListHere && Object.entries(productListHere).length > 0) &&
          <li>
            <div className="no-part-data">
              {__check(['PRODUCT_MANUAL_SEARCH_LISTING_API_CALL', 'PRODUCT_INVENTORY_API_CALL', 'MANUAL_SEARCH_API_CALL']).status &&
                <i className="cursor-pointer fa fa-spinner fa-spin" />
              }
              {!__check(['PRODUCT_MANUAL_SEARCH_LISTING_API_CALL', 'PRODUCT_INVENTORY_API_CALL', 'MANUAL_SEARCH_API_CALL']).status &&
                <>(0)</>
              } Results Found
            </div>
          </li>
        }
      </>
    )
  };

  return (
    <>
      <div id="manual-add-part-box" className={classToToggle} ref={wrapperRef}>
        <div className='position-relative'>
          <input className="cart-head-input h30" type="text" placeholder={props.fromComponent === "myCart" ? "Type Part Number" : "Enter part #"}
            value={(productSelected && productSelected.ERPMFRPartNumber) ? productSelected.ERPMFRPartNumber : searchTerm ? searchTerm : ''}
            autoComplete={'off'}
            onChange={(e) => {
              setSearchTerm(e.target.value)
            }}
            onPaste={(e) => {
              setSearchTerm('');
              setProductSelected({})
            }}
            onKeyUp={(e) => {
              setKeyPress(true)
              setProductSelected({})
            }}
          />
        </div>
        <div className="dropdown-menu search-part-dropdown search-part-cart-dropdown"
          aria-labelledby="search-dropdown">
          {Object.entries(searchProductList).length > 1 &&
            <>
              <div className="more-products-step">
                <div className='bg-grey2'>
                  <button type='button' className='more-products-step-back bg-transparent' onClick={() => {
                    setClassToToggle(clsOpen); // re-open list
                    setSearchProductList({});
                    setTimeout(() => {
                      setBackButtonClick(true);
                    }, 800)
                  }}>
                    <a className='text-blue2' href={void (0)}>
                      <i className='me-1'><img src={addpartarrow} className="" /></i>
                      <span>Back</span>
                    </a>
                  </button>
                </div>
                <div className='more-products-step-info'>
                  ({Object.entries(searchProductList).length}) Products found
                  in {searchProductList[0].ManufacturerName}
                </div>
                <ul>
                  {getProductItem(searchProductList)}
                </ul>
              </div>
            </>
          }
          {__check(['PRODUCT_MANUAL_SEARCH_LISTING_API_CALL', 'PRODUCT_INVENTORY_API_CALL', 'MANUAL_SEARCH_API_CALL']).render}
          {Object.entries(searchProductList).length < 1 &&
            <ul className={Object.entries(productListGroup).length > 5 ? 'auto-search-scroll' : ''}>
              {getProductGroupItem(productListGroup)}
            </ul>
          }
        </div>
      </div>
    </>
  );
};

export default AddPartAutoComplete;